import { MeasurementUnit } from '@shure/shared/angular/data-access/system-api/models';

import { unitBasedRound } from './round';

const RAW_MM_TO_METERS_RATIO = 1000; // mm/m
const RAW_MM_TO_FEET_RATIO = 304.8; // mm/ft
const RAW_MM_TO_PX_RATIO = 10; // px/mm

/**
 * Convert a raw value (1 millimeter) to pixels.
 */
export function rawToPx(rawValue: number): number {
	return rawValue / RAW_MM_TO_PX_RATIO;
}

/**
 * Convert a px value to raw value (1 millimeter).
 */
export function pxToRaw(pxValue: number): number {
	return pxValue * RAW_MM_TO_PX_RATIO;
}

function rawToMeters(rawValue: number): number {
	return rawValue / RAW_MM_TO_METERS_RATIO;
}

function metersToRaw(metersValue: number): number {
	return metersValue * RAW_MM_TO_METERS_RATIO;
}

function rawToFeet(rawValue: number): number {
	return rawValue / RAW_MM_TO_FEET_RATIO;
}

export function feetToMeters(feetValue: number): number {
	return unitBasedRound(feetValue / 3.28084, MeasurementUnit.Meters);
}

function feetToRaw(feetValue: number): number {
	return feetValue * RAW_MM_TO_FEET_RATIO;
}

/**
 * Convert a raw value (1 millimeter) to a measurement unit.
 */
export function rawToMeasurementUnit(rawValue: number, measurementUnit: MeasurementUnit): number {
	return measurementUnit === MeasurementUnit.Feet ? rawToFeet(rawValue) : rawToMeters(rawValue);
}

export function pxToMeasurementUnit(pxValue: number, measurementUnit: MeasurementUnit): number {
	const rawValue = pxToRaw(pxValue);
	return rawToMeasurementUnit(rawValue, measurementUnit);
}

export function measurementUnitToPx(value: number, measurementUnit: MeasurementUnit): number {
	const rawValue = measurementUnitToRaw(value, measurementUnit);
	return rawToPx(rawValue);
}

export function measurementUnitToRaw(value: number, measurementUnit: MeasurementUnit): number {
	return measurementUnit === MeasurementUnit.Feet ? feetToRaw(value) : metersToRaw(value);
}
